<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py"> DISTRICT OCCURRENCE</h4>
                <div style="width:120px">
                    <button type="button" [hidden]="isButtonDisabled" class="btn btn-block btn-primary"
                        data-toggle="modal" data-target="#myModal" (click)="setCurrentdate()">Add</button>
                </div>
            </div>
        </div>
        <div *ngIf="!tableshow" style="margin-left: 50%;">
            <div class="loader"></div>
        </div>

        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card">

                        <div class="card-header show-header ">
                            <h3 class="card-title">ADD DISTRICT OCCURRENCE</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>

                        <div class="card-body">
                            <form class="register-form" [formGroup]='createmeetingform'
                                (ngSubmit)="postdata(createmeetingform)" autocomplete="off">
                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Course Name</label><span class="required "> *</span>
                                        <select name="course_name" class="form-control" formControlName="course_name">
                                            <option value="">Select Course Name</option>
                                            <option *ngFor="let option of courses" [value]="option.id">
                                                {{option['course_name']}}</option>

                                        </select>
                                        <div *ngIf="createmeetingform.get('course_name').touched &&  createmeetingform.get('course_name').value ==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                    <div class="row" style="display:none">
                                        <input type="number" formControlName="user_id" />
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">District</label><span class="required "> *</span>
                                        <input type="text" formControlName="district" readonly class="form-control"
                                            [value]="userDistrict" />
                                        <div *ngIf="createmeetingform.get('district').touched &&  createmeetingform.get('district').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <!-- <div class="col-md-6">
                                        <label class="form-label">Constituency</label>
                                        <input type="text" formControlName="constituency" readonly class="form-control" [value]="userConstituency" />
                                        <div *ngIf="createmeetingform.get('constituency').touched &&  createmeetingform.get('constituency').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div> -->
                                    <div class="col-md-12">
                                        <label class="form-label">Organizer</label>
                                        <input type="text" formControlName="organizer" class="form-control" [value]=" "
                                            readonly />

                                        <!-- <select name="organizer" class="form-control" formControlName="organizer">
                                            <option value="">Select Organizer</option>
                                            <option value="class">Class</option>
                                            <option *ngFor="let option of ob_data" (value)="option['firstname']">
                                                {{option['firstname']}}</option>
                                        
                                        </select> -->
                                        <div *ngIf="createmeetingform.get('organizer').touched &&  createmeetingform.get('organizer').value==''"
                                            class="invalid-msg">Please fill the field </div>

                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="form-label">Course Start Date</label><span
                                            class="required">*</span>
                                        <input type="date" class="form-control" formControlName="course_start_date"
                                            placeholder="Enter Course Start Date" [min]="getCurrentDates()">
                                        <div *ngIf="createmeetingform.get('course_start_date').touched &&  createmeetingform.get('course_start_date').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="form-label">Course End Date</label><span class="required">*</span>
                                        <input type="date" class="form-control" formControlName="course_end_date"
                                            placeholder="Enter Course End Date" [min]="getCurrentDates()">
                                        <div *ngIf="createmeetingform.get('course_end_date').touched &&  createmeetingform.get('course_end_date').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>

                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="form-label">Course Start Time</label><span
                                            class="required">*</span>
                                        <input type="time" class="form-control" formControlName="course_start_time"
                                            placeholder="Enter Course Start Time" />
                                        <div *ngIf="createmeetingform.get('course_start_time').touched &&  createmeetingform.get('course_start_time').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Course End Time</label><span class="required">*</span>
                                        <input type="time" class="form-control" formControlName="course_end_time"
                                            placeholder="Enter Course End Time" />
                                        <div *ngIf="createmeetingform.get('course_end_time').touched &&  createmeetingform.get('course_end_time').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="form-label">Primary Volunteer</label><span
                                            class="required">*</span>
                                        <select class="form-control" formControlName="volunteer1">
                                            <option value="" selected disabled hidden>Select Primary Volunteer</option>
                                            <option *ngFor="let mentor of mentor_data" (value)="mentor.id">
                                                {{mentor.first_name}}</option>
                                        </select>
                                        <div *ngIf="createmeetingform.get('volunteer1').touched &&  createmeetingform.get('volunteer1').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Secondary Volunteer</label>
                                        <select class="form-control" formControlName="volunteer2">
                                            <option value="" selected disabled hidden>Select Secondary Volunteer
                                            </option>
                                            <option *ngFor="let mentor of mentor_data" (value)="mentor.id">
                                                {{mentor.first_name}}</option>
                                        </select>
                                        <!-- <div *ngIf="createmeetingform.get('volunteer2').touched &&  createmeetingform.get('volunteer2').value==''"
                                            class="invalid-msg">Please fill the field </div> -->
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label class="form-label">Course Location</label><span class="required">*</span>
                                        <input type="text" class="form-control" formControlName="course_location"
                                            placeholder="Enter Course Location" />
                                        <div *ngIf="createmeetingform.get('course_location').touched &&  createmeetingform.get('course_location').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Status</label><span class="required">*</span>
                                        <select name="status" class="form-control" formControlName="status">
                                            <option value="">Select any status </option>
                                            <option>Open</option>
                                            <option>Session Start</option>
                                            <option>Session End</option>
                                            <option>Inprogress</option>
                                            <option>Cancelled</option>
                                            <option>Postponed</option>
                                        </select>
                                        <div *ngIf="createmeetingform.get('status').touched &&  createmeetingform.get('status').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="form-label">Session link</label>
                                        <span
                                            class="required"></span>  
                                        <input type="text" class="form-control" formControlName="session_link"
                                            placeholder="Enter Session Link" />
                                        <!-- <div *ngIf="createmeetingform.get('session_link').touched &&  createmeetingform.get('session_link').value==''"
                                            class="invalid-msg">Please fill the field </div> -->
                                            <div *ngIf="createmeetingform.get('session_link').hasError('invalidLink')"  class="invalid-msg">Invalid Session Link.</div>

                                    </div>

                                </div>
                                <div class="form-group">
                                    <div>
                                        <label>Comments</label> <span
                                        class="required">*</span>
                                        <textarea type="text" class="form-control" formControlName="comments"
                                            placeholder="Comments"></textarea>
                                             <div *ngIf="createmeetingform.get('comments').touched &&  createmeetingform.get('comments').value==''"
                                            class="invalid-msg">Please fill the field </div>
                                           </div>
                                </div>

                                <div class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary btn btn-block" [disabled]="createmeetingform.invalid">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mt-4" *ngIf="customers.length > 0">
            <div class="col-md-12">



                <div class="row">
                    <div class="col-md-4" *ngFor="let item of customers">
                        <div class="card">
                            <img class="card-img-top" style="height: 200px;" 
                            src="https://myroots.redmindtechnologies.com/api/{{item.image}}"
                                alt="Card image">
                            <div class="card-body">
                                <h4 class="card-title" style="font-weight:bold;font-size:16px;">{{item.course_name}}
                                </h4>
                                <div class="card-text" style="font-size: 12px;">{{item.course_description}}</div>
                                <span class="card-text" style="float:left">Start Date: {{item.start_date |
                                    date:'d-M-Y'}}</span>
                                <div class="card-text" style="font-size: 14px;">Duration: {{item.hours}} Hours</div>
                                <br />
                                <button class="btn btn-primary" style="float: right;margin-right: 20px;"
                                    data-toggle="modal" data-target="#showCM"
                                    (click)="buttonviewmeeting(item,'show')">Show</button>

                                <button class="btn btn-danger" style="float: right;margin-right: 20px;"
                                    (click)="delete_CM(item.id)">Delete</button>

                                <button class="btn btn-primary" style="float: right;margin-right: 20px;"
                                    data-toggle="modal" data-target="#showCM"
                                    (click)="buttonviewmeeting(item,'edit')">Edit</button>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Course Name</th>
                            <th>Location</th>
                            <th>Course Start </th>
                            <th>Course End </th>
                            <th>Show</th>
                            <th >Edit</th>
                            <th>Cancel</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers">
                            <td style="min-width: 20px;">
                                {{customer['course_name']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['location']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['start_date'] | date:'dd-MM-YYYY'}} {{customer['start_time']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['end_date'] | date:'dd-MM-YYYY'}} {{customer['end_time']}}
                            </td>

                            <td [hidden]="isButtonDisabled"><a data-toggle="modal" data-target="#showCM"
                                    class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')">
                                    <i class="fas fa-flag"></i>
                                </a></td>
                            <td [hidden]="isButtonDisabled"><button data-toggle="modal" data-target="#showCM"
                                    [disabled]="customer.status=='cancel'" class="btn btn-info btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'edit')">
                                    <i class="fas fa-check"></i>
                                </button></td>
                            <td><a 
                                    class="btn btn-success btn-circle btn-sm" >
                                    <i class="fas fa-times"></i>
                                </a></td>
                            <ng-template #notShow [hidden]="isButtonDisabled">
                                <a *ngIf="customer.status=='cancel'">
                                    Cancelled

                                </a>
                            </ng-template>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div> -->


        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card">
                        <div class="card-header show-header">
                            <h3 class="card-title">District Occurrence </h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Course Name   <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_course_name    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">District  <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_district  }}</h6>
                            </div>
                        </div>

                                </div>
                                
                             
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Organizer <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_organizer    }}</h6>
                                </div>
                            </div>
                                </div>
                                
                                
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Course Start Date  <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_startDate    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course End Date  <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_endDate  }}</h6>
                            </div>
                        </div>

                                </div>

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Course Start Time  <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_startTime    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course End Time <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_endTime  }}</h6>
                            </div>
                        </div>

                                </div>

                             
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Primary Volunteer<span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_volunteer1    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Secondary Volunteer <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_volunteer2  }}</h6>
                            </div>
                        </div>

                                </div>
                            
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Course Location<span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_location    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Status<span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_status  }}</h6>
                            </div>
                        </div>

                                </div>

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Session link<span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_session_link    }}</h6>
                                </div>
                            </div>
                          
                                </div>

                                
                                    <!-- Course Name Field -->
                                    <div class="form-group row" *ngIf="editfield">
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Course Name </label><span class="required">*</span>
                                            <select class="form-control" formControlName="course_name">
                                                <option value="">Select Course Name</option>
                                                <option *ngFor="let option of courses" [value]="option.course_name">{{ option.course_name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                
                                    <!-- District Field -->
                                    <div class="form-group row" *ngIf="editfield">
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>District</label><span class="required">*</span>
                                            <input type="text" class="form-control" formControlName="district" readonly />
                                        </div>
                                    </div>
                                
                                    <!-- Organizer Field -->
                                    <div class="form-group row" *ngIf="editfield">
                                        <div class="col-sm-12 mb-3 mb-sm-0">
                                            <label>Organizer</label><span class="required">*</span>
                                            <input type="text" class="form-control" formControlName="organizer" readonly />
                                        </div>
                                    </div>
                                
                                    <!-- Date and Time Fields -->
                                    <div class="form-group row" *ngIf="editfield">
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Course Start Date</label><span class="required">*</span>
                                            <input type="date" class="form-control" formControlName="course_start_date" />
                                        </div>
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Course End Date</label><span class="required">*</span>
                                            <input type="date" class="form-control" formControlName="course_end_date" />
                                        </div>
                                    </div>
                                
                                    <div class="form-group row" *ngIf="editfield">
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Course Start Time</label><span class="required">*</span>
                                            <input type="time" class="form-control" formControlName="course_start_time" />
                                        </div>
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Course End Time</label><span class="required">*</span>
                                            <input type="time" class="form-control" formControlName="course_end_time" />
                                        </div>
                                    </div>
                                
                                    <!-- Other Fields -->
                                    <div class="form-group row" *ngIf="editfield">
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Primary Volunteer</label><span class="required">*</span>
                                            <input type="text" class="form-control" formControlName="volunteer1" readonly />
                                        </div>
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Secondary Volunteer</label><span class="required">*</span>
                                            <input type="text" class="form-control" formControlName="volunteer2" readonly />
                                        </div>
                                    </div>
                                
                                    <!-- Status Field -->
                                    <div class="form-group row" *ngIf="editfield">
                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                            <label>Status</label><span class="required">*</span>
                                            <select class="form-control" formControlName="status">
                                                <option value="">Select any status</option>
                                                <option>Open</option>
                                                <option>Session Start</option>
                                                <option>Session End</option>
                                                <option>Inprogress</option>
                                                <option>Cancelled</option>
                                                <option>Postponed</option>
                                            </select>
                                        </div>
                                    </div>
                                
                                    <!-- Comments Field -->
                                    <div class="form-group row" *ngIf="editfield">
                                        <div class="col-md-12">
                                            <label>Comments</label>
                                            <textarea class="form-control" formControlName="comments"></textarea>
                                        </div>
                                    </div>
                                
                                    <!-- Submit Button -->
                                  
                                

                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary btn btn-block">Update</button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>